/* src/app/module/service-provider/add-sp-new-component/business-details-new/business-details-new.component.scss */
.formly-field {
  margin-bottom: 15px;
}
.heading {
  margin-bottom: 22px;
  font-size: 20px;
  font-weight: 600;
}
::ng-deep h3 {
  margin-top: 0px;
  margin-bottom: 10px;
}
.p-col-12 {
  margin-bottom: 1em;
}
.p-button {
  margin-top: 1em;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
  font-weight: bold;
}
form {
  width: 750px;
}
::ng-deep .p-inputtext,
::ng-deep .p-dropdown {
  width: 360px !important;
  height: 44px !important;
  border: 1px solid #D0D5DD !important;
  border-radius: 8px !important;
  background: #FFF !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 10px 14px !important;
  font-size: 16px;
  font-weight: 400;
  color: #344054 !important;
  display: flex;
  align-items: center;
  margin-top: 6px;
}
::ng-deep .p-dropdown span {
  margin: 0px;
}
::ng-deep .p-inputtext::placeholder,
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: #667085 !important;
  font-size: 16px;
  font-weight: 400;
}
::ng-deep input:-webkit-autofill {
  background-color: white !important;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: black !important;
}
::ng-deep .p-inputtext:focus,
::ng-deep .p-inputtext:hover,
::ng-deep .p-dropdown:focus,
::ng-deep .p-dropdown:hover,
::ng-deep input:hover,
input:focus {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px #F4EBFF !important;
}
::ng-deep .p-dropdown.p-focus,
::ng-deep .p-dropdown.p-highlight,
::ng-deep .p-dropdown:focus-within,
::ng-deep input.p-focus,
::ng-deep input.p-highlight {
  border-color: orange !important;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px #F4EBFF !important;
}
::ng-deep .p-dropdown-label {
  padding: 0 !important;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #344054;
  height: 100%;
  width: 100%;
}
::ng-deep .p-dropdown .p-inputtext {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
::ng-deep .p-dropdown-trigger {
  justify-content: flex-end;
  color: #667085;
}
::ng-deep formly-field {
  width: 360px !important;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 4px 8px;
  border-radius: 6px;
  padding: 6px 12px;
}
::ng-deep .p-dropdown-item.p-highlight {
  color: #D47500;
  background: #FFC680;
}
::ng-deep .p-dropdown-item.p-highlight.p-focus {
  background: #FFF1E0;
}
::ng-deep .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
::ng-deep .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
/*# sourceMappingURL=business-details-new.component-VPOZLLG2.css.map */
